import React from "react";
import { Loader2 } from "lucide-react";

function LoadingCard({ small = false }) {
  return (
    <div
      className={[
        "flex items-center justify-center rounded-xl border border-[#d8e7ed] bg-[#f8fbfc] dark:border-dark-border dark:bg-dark-surface",
        small ? "h-24" : "h-32",
      ].join(" ")}
    >
      <div className="flex items-center gap-2 text-[10px] font-medium text-[#8194a0] dark:text-dark-text-muted">
        <Loader2
          size={15}
          className="animate-spin text-[#147db5] dark:text-dark-primary"
        />

        Loading...
      </div>
    </div>
  );
}

export default LoadingCard;
